import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FlamingoHttpService } from '@flamingo/service/flamingo-http.service';
import { Observable } from 'rxjs';
import { AuctionView } from '../../../../../../core/model/auction-view.model';
import { Attachment } from '../../../../../../core/model/invoice.model';
import { PaginatedList } from '../../../../../../core/model/paginated-list.model';

@Injectable({
  providedIn: 'root',
})
export class AuctionSellerService {
  constructor(private _httpService: FlamingoHttpService) {
  }

  public list(
    page?: number,
    pageSize?: number,
    sort?: string,
    sortOrder?: string,
    filter?: string,
    type?: string,
  ): Observable<PaginatedList<AuctionView>> {
    const params = new HttpParams()
      .set('page', page ? `${page}` : '0')
      .set('pageSize', pageSize ? `${pageSize}` : '10')
      .set('sort', sort ? sort : '')
      .set('sortOrder', sortOrder ? sortOrder : 'DESC')
      .set('filter', filter ? filter : '');

    switch (type) {
      case 'ALL':
        return this._httpService.get(`/auction-view/sent`, params);
      case 'PENDING_INVOICE_VALIDATION':
        return this._httpService.get(`/auction-view/sent/pending-invoice-validation`, params);
      case 'PENDING_DEBTOR_VALIDATION':
        return this._httpService.get(`/auction-view/sent/pending-debtor-validation`, params);
      case 'READY':
        return this._httpService.get(`/auction-view/sent/ready`, params);
      case 'INVALID':
        return this._httpService.get(`/auction-view/sent/invalid`, params);
      case 'EXPIRED':
        return this._httpService.get(`/auction-view/expired`, params);
      case 'SOLD_ACTIVE':
        return this._httpService.get(`/auction-view/sold-pending-settlement`, params);
      case 'SOLD_ARCHIVED':
        return this._httpService.get(`/auction-view/sold-paid`, params);
      default:
        return this._httpService.get(`/auction-view/sold`, params);
    }
  }

  public listToday(
    page?: number,
    pageSize?: number,
    sort?: string,
    sortOrder?: string,
    filter?: string,
  ): Observable<PaginatedList<AuctionView>> {
    const params = new HttpParams()
      .set('page', page ? `${page}` : '0')
      .set('pageSize', pageSize ? `${pageSize}` : '10')
      .set('sort', sort ? sort : '')
      .set('sortOrder', sortOrder ? sortOrder : 'ASC')
      .set('filter', filter ? filter : '');

    return this._httpService.get(`/auction-view/active`, params);
  }

  public getSentInvoiceAttachments(invoiceId: string): Observable<Attachment[]> {
    return this._httpService.get(`/invoice/sent/${invoiceId}/attachment`);
  }

  public updateSentInvoiceAttachment(
    body: any,
    invoiceId: string,
    attachmentId: number,
  ): Observable<Attachment> {
    const url = `/invoice/sent/${invoiceId}/attachment/${attachmentId}`;
    return this._httpService.put(url, body);
  }

  public updateSentInvoiceAttachmentFile(
    data: FormData,
    invoiceId: string,
    attachmentId: number,
  ): Observable<Attachment> {
    const url = `/invoice/sent/${invoiceId}/attachment/${attachmentId}/file`;
    return this._httpService.putFormData(url, data);
  }

  public downloadSentInvoiceAttachment(invoiceId: string, attachmentId: number): Observable<any> {
    return this._httpService.getUrl(`/invoice/sent/${invoiceId}/attachment/${attachmentId}`);
  }
}
